import { rest } from 'msw';
import {
  authorizationEndpoint,
  baseUrl,
  blacklistPermissions,
  permissionsEndpoint,
  userAccessRequestEndpoint,
} from '../../constants';
import {
  getAccessRequestData,
  getBlacklistPermissionsMockResponse,
  mockAccessRequestResponse,
  mockPermissions,
  postBlacklistPermissionsMockResponse,
} from '../mocks';

export const fetchPermissions = (addDelay?: boolean) =>
  rest.get(`${baseUrl}${authorizationEndpoint}${permissionsEndpoint}/:upn`, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(mockPermissions),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const getBlacklistPermissionsData = (addDelay?: boolean) =>
  rest.get(`${baseUrl}${authorizationEndpoint}${blacklistPermissions}/:storeId`, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(getBlacklistPermissionsMockResponse),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const postBlacklistPermissionsData = (addDelay?: boolean) =>
  rest.post(`${baseUrl}${authorizationEndpoint}${blacklistPermissions}/:storeId`, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(postBlacklistPermissionsMockResponse),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const userAccessRequestData = (addDelay?: boolean) =>
  rest.post(`${baseUrl}${authorizationEndpoint}/:upn${userAccessRequestEndpoint}`, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(mockAccessRequestResponse),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const fetchAccessRequest = (addDelay?: boolean) =>
  rest.get(`${baseUrl}${authorizationEndpoint}${userAccessRequestEndpoint}`, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(getAccessRequestData()),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });

export const fetchRequestedAssignments = (addDelay?: boolean) =>
  rest.get(`${baseUrl}${authorizationEndpoint}/requestedAssignments`, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(getAccessRequestData()),
      ctx.set('Content-Type', 'application/json'),
      ctx.delay(addDelay ? 500 : 0),
    );
  });
